import { Text, TextProps } from "@chakra-ui/react";
import React from "react";

type ColumnHeaderProps = {
  children: React.ReactNode;
} & TextProps;

const ColumnHeader: React.FC<ColumnHeaderProps> = ({ children, ...styles }) => {
  return (
    <Text fontSize="sm" textTransform="uppercase" color="gray.600" {...styles}>
      {children}
    </Text>
  );
};

export default ColumnHeader;
